import { createPortal } from 'react-dom'
import { cn } from '@/lib/utils.ts'
import { MENU_SELECT_TOGGLE_DURATION } from '@/lib/constants/animationsSettings.ts'

type PropsT = {
  className?: string
  open?: boolean
  handleClick?: () => void
}
export default function OverlayBackdrop({ className, open, handleClick }: PropsT) {
  // Portal to body for the same reason as OverlaySelectWrapper:
  // `position: fixed` is broken by any transformed ancestor (route
  // animation wrappers, framer-motion shells), pinning the backdrop to
  // somewhere other than the viewport. Portaling guarantees the
  // backdrop fills the actual viewport regardless of where in the
  // React tree it was rendered.
  return createPortal(
    <div
      onClick={handleClick}
      className={cn(
        `fixed bottom-0 left-0 top-0 z-[1000] w-full bg-black/50 md:w-[var(--sidebar-width)] md:bg-black/10`,
        open ? `opacity-100` : `pointer-events-none opacity-0`,
        MENU_SELECT_TOGGLE_DURATION,
        className,
      )}
    ></div>,
    document.body,
  )
}
